<template>
  <u-page>
    <div slot="content">
      <div class="list">
        <a @click="click(1)">发起抢答useID:{{userID}} answerID:{{answerID}}</a>
        <a @click="click(2)">老师查看抢答useID:{{userID}} answerID:{{answerID}}</a>
        <a @click="click(3)">学生查看抢答useID:{{userID}} answerID:{{answerID}}</a>
        <a @click="click(4)">进入分步页面useID:{{userID}} answerID:{{answerID}} role:{{role}}</a>
        <!--<a @click="click(4)">学生查看作业useID:{{userID}} answerID:{{answerID}}</a>-->
        <!--<a @click="click(5)">学生写作业useID:{{userID}} answerID:{{answerID}}</a>-->
        <!--<a @click="click(6)">分享作业useID:{{userID}} answerID:{{answerID}}</a>-->
        <!--<a @click="click(7)">查重useID:{{userID}} answerID:{{answerID}}</a>-->
        <!--<a @click="click(8)">资源详情useID:{{userID}} answerID:{{answerID}}</a>-->
      </div>

      <div class="form">
        <label class="">
          userID
          <input type="Number" v-model="userID">
        </label>
        <label>
          活动ID
          <input type="Number" v-model="answerID">
        </label>
        <label>
          role
          <input type="Number" v-model="role">
        </label>
        <label>
          查重使用studentID
          <input type="Number" v-model="studentID">
        </label>
        <label>
          userName
          <input type="String" v-model="userName">
        </label>
      </div>
      <div>
        <button @click="submitClick">登陆</button>
      </div>

    </div>

  </u-page>

</template>

<script type="text/ecmascript-6">
  import UPage from 'common/components/u-page'

  export default {
    data () {
      return {
        userID: '708215',
        answerID: '-1',
        role: 8,
        studentID: 552752,
        userName: 'huangqiantea'
      }
    },
    created () {
    },
    methods: {
      submitClick: function () {
      },
      onDeviceReady: function () {
        console.log(window.cordova)
      },
      click: function (type) {
        if (type === 1) {
//          Uloading.showToast(new Vue(), {
//            content: 'sdfsdfsdf'
//          })
//          发起作业
          this.$router.push(`answer/publish/${this.userID}/${this.answerID}?animation=false`)
        } else if (type === 2) {
//         老师查看作业列表
          this.$router.push(`answer/check/${this.userID}/${this.answerID}/1`)
        } else if (type === 3) {
//          老师查看作业详情
          this.$router.push(`answer/stuDetail/${this.userID}/${this.answerID}`)
        } else if (type === 4) {
//          answer/start/:userID/:answerID/:role
          this.$router.push(`answer/start/${this.userID}/${this.answerID}/${this.role}`)

//          学生查看作业
//          this.$router.push(`stuDetail/${this.userID}/${this.answerID}`)
        } else if (type === 5) {
          this.$router.push(`stuWriting/${this.userID}/${this.answerID}`)
        } else if (type === 6) {
          this.$router.push(`shareWork/${this.userID}/${this.answerID}`)
        } else if (type === 7) {
          this.$router.push(`repeatReport/${this.userID}/${this.answerID}/552752`)
        } else if (type === 8) {
          this.setAttach({
            fileType: 'ppt',
            filePath: '/homework/0/1044140/59e5fa1e-c50c-4bc7-940c-e2c45c88f9c3.ppt',
            fileName: 'ppt.xls',
            fileSize: '19456'
          })
          this.$router.push(`attachDetail`)
        }
      }
    },
    components: {
      UPage
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .list
    > a
      display: inline-block
      width: 100%
      height: 44px
      font-size: 18px

  .form
    label
      display: inline-block
      width: 100%
    input
      border-bottom: 1px solid
</style>



// WEBPACK FOOTER //
// src/common/components/start.vue